import LegalDocument from '../components/LegalDocument'

const TosPage = () => <LegalDocument document='terms' />

export default TosPage
